import React, { useState } from 'react';

import { mdiPlus } from '@mdi/js';
import Icon from '@mdi/react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import ClassesContainer from './ClassesContainer';
import ClassesTableBody from './ClassesTableBody';
import Modal, { ModalSize } from '../../../../components/Modal';
import { ClassContainer } from '../../../ClassModal/ClassContainer';
import ClassForm from '../../../ClassModal/ClassForm';
import StyledFormTitle from '../../styles/form-title';
import { StyledActionButton } from '../../styles/table-styles';

const StyledHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const Title = styled(StyledFormTitle)`
    margin-bottom: 1rem;
`;

const PlusIcon = styled(Icon)`
    color: inherit;
    min-width: 20px;
    margin-right: 0.5rem;
`;

export const ClassesTable: React.FC = () => {
    const { fetchClasses } = useContainer(ClassesContainer);
    const { onCancel } = useContainer(ClassContainer);
    const [createClassOpen, setCreateClassOpen] = useState(false);

    const { t } = useTranslation('admin_settings');
    const handleCloseModal = () => {
        setCreateClassOpen(false);
        onCancel();
    };

    const handleClassCreateSuccess = async () => {
        handleCloseModal();
        await fetchClasses();
    };

    return (
        <>
            <StyledHeader>
                <Title>{t('classes.title')}</Title>
                <StyledActionButton variant="contained" onClick={() => setCreateClassOpen(true)}>
                    <PlusIcon path={mdiPlus} /> {t('classes.create-a-class')}
                </StyledActionButton>
                <Modal noPadding isOpen={createClassOpen} onClose={handleCloseModal} size={ModalSize.Large}>
                    <ClassForm onClose={handleCloseModal} onSuccess={handleClassCreateSuccess} admin={true} />
                </Modal>
            </StyledHeader>
            <ClassesTableBody />
        </>
    );
};
